module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Regular.b876dbdde476dab54c049530812070a1.eot";